export type BrokerNerdsBarkerCoreEnumsPointOfSale = (typeof BrokerNerdsBarkerCoreEnumsPointOfSale)[keyof typeof BrokerNerdsBarkerCoreEnumsPointOfSale];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsPointOfSale = {
  Unknown: 'Unknown',
  Ephemera: 'Ephemera',
  SkyBox: 'SkyBox',
  PosNext: 'PosNext',
  TicketUtils: 'TicketUtils',
  TradeDeskPos: 'TradeDeskPos',
  DtiPortal: 'DtiPortal',
  TicketNetwork: 'TicketNetwork',
  AnyTickets: 'AnyTickets',
  EIBO: 'EIBO',
  VictoryLiveOne: 'VictoryLiveOne',
  TicketSuite: 'TicketSuite',
} as const;
